$(function(){
	// Communs
    var gestionMenu = function() {
		$body = $('body');
		$btnMenu = $('.btnMenu');
		$menu = $('.menu');

		$btnMenu.on('touchstart click',function(e){
			e.preventDefault();

			/* Cross browser support for CSS "transition end" event */
      		transitionEnd = 'transitionend webkitTransitionEnd otransitionend MSTransitionEnd';

			$body.addClass('animating left');

			$menu.on( transitionEnd, function() {
				$body
				.removeClass( 'animating left' )
				.addClass( 'menu-open' );

				$menu.off( transitionEnd );
			});
		});
		
		$body.on('touchstart click', ($menu, $btnMenu), function(e){
			$target = $(e.target);
			var isActive = false;
			if($target.hasClass('menu') || ($body.hasClass('menu-open') && ($target.hasClass('btnMenu') || $target.hasClass('icon-bar')))) {
                e.preventDefault();
				/* Cross browser support for CSS "transition end" event */
	      		transitionEnd = 'transitionend webkitTransitionEnd otransitionend MSTransitionEnd';

				$body.addClass('animating right');
				
				$menu.on( transitionEnd, function() {
					$body
					.removeClass( 'animating right menu-open' );

					$menu.off( transitionEnd );
				});
                
			}
		});
	}; 
    
    var scrollHeaderMobile = function () {
        function stickyHeader() {
            if($(window).scrollTop() > 0) {
                $('body').addClass('sticky');
            } else {
                $('body').removeClass('sticky');
            }
        }
        $(window).scroll(stickyHeader);
        stickyHeader();
    }
    
    
    // Home
    var loadHome = function() {
        $body = $('body');
        $lastElementAnimate = $('.home .conseiller');
         
        if($lastElementAnimate.lenght > 0) {
            /* Cross browser support for CSS "transition end" event */
            animationEnd = 'webkitAnimationEnd oanimationend msAnimationEnd animationend';
            $body.addClass('loading');

            $lastElementAnimate.one( animationEnd, function() {
                $body.removeClass( 'loading' );
                $lastElementAnimate.last().off( animationEnd );
            });
        }
     };
    
    // Mon compte
    var selectMonCompte = function() {
        if($('.compte').length > 0) {
            $selectpicker = $('.compte .selectpicker');
            $radioButtons = $('.compte input[name="formPrefContact"]');
            
            $selectpicker.on('change', function(){
                $('#formPrefContact_' + $(this).val()).prop('checked', true);
            });
            $radioButtons.on('change', function(){
                $selectpicker.selectpicker('val', $(this).val());
            });
        }
     };


     // declaration des litiges  // declaration-litige.html
    $("#formQualite").on("change", function(){
        if ( $(this).val() == "personne-morale"){
            $("#row-nom-prenom").css("display","none");
            $("#civilite_bloc").css("display","none");
            $("#raisonSocial_bloc").css("display","block");
        }
        if ($(this).val() == 'personne-physique'){
            $("#civilite_bloc").css("display","block");
            $("#row-nom-prenom").css("display","block");
            $("#raisonSocial_bloc").css("display","none");
        }

    });


    // page detail-litige.html : js dropdown menu "detail des actes"
    $(".ddct_title").on("click", function(){
        $(this).next(".ddct_detail").toggleClass("close");
        $(this).children(".icon-drop").toggleClass("up");

    });


    // cookie
    $(".cookies-bar .cb-main .btn-ok").on("click", function(){
        $(".cookies-bar").css("display", "none");

    });


    // retour en arrier ( historique navigateur )

    $(".retourHistory").on("click", function(){
         // alert ("retour en arriere : href 02 ");
        //  history.go(-1);
        //  history.back(-1);
        $(this).attr("href","javascript:history.back(-1)");
    });


    gestionMenu();
    scrollHeaderMobile();
    loadHome();
    selectMonCompte();
});